module.exports = __webpack_public_path__ + "img/C3.9bc23eb2.jpg";